<template>
	<!-- 生态伙伴 -->
	<div>
		<div>
			<pageHeader :headerImg="config.headerImg" :headerTitle="config.headerTitle" :headerDesc="config.headerDesc">
			</pageHeader>
			<div class="content">
				<div class="content-title">{{ config.title }}</div>
				<div class="customer-content">
					<div v-for="(item, itemIndex) in config.contentData" :key="itemIndex" class="customer-item">
						<el-image class="customer-item-img" :key="item.src" :src="item.src" lazy></el-image>
						<div class="customer-item-title">{{ item.title }}</div>
						<div class="customer-item-info">{{ item.info }}</div>
					</div>
				</div>
			</div>
			<div class="partner">
				<div class="partner-title">{{ config.partnerTitle }}</div>
				<div class="partner-content">
					<div v-for="(item, itemIndex) in config.partnerData" :key="itemIndex" class="partner-item">
						<div class="partner-item-img">
							<img :src="item.src"></img>
						</div>
						<div class="partner-item-title">{{ item.title }}</div>
						<div class="partner-item-info">{{ item.info }}</div>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="footer-text">

				</div>
			</div>
			<appService></appService>
		</div>
	</div>
</template>

<script>
import { config } from './partner'
import pageHeader from '../common/page_header'
import appService from "../common/appService.vue";
export default {
	name: '',
	components: { pageHeader, appService },
	data() {
		return {
			config: config,
			dialogVisible: false,
			formInline: {}
		};
	},
	computed: {
	},
	watch: {
	},
	methods: {
		dialogClick() {
			this.dialogVisible = true
		},
	},
};
</script>

<style scoped lang="less">
.content {
	padding: 110px 68px 68px;
	background: @mainBgColor;

	.content-title {
		margin-bottom: 50px;
		color: #fff;
		font-size: 40px;
	}

	.customer-content {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		column-gap: 35px;
		color: @mainTextColor;

		.customer-item {
			.customer-item-img {
				width: 100%;
			}

			.customer-item-title {
				margin: 20px 0px;
				font-size: @fontSize20;
			}

			.customer-item-info {
				font-size: @fontSize14;
				color: @mainGrayColor;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}


		}
	}
}

.partner {
	.partner-title {
		padding: 120px 68px 60px;
		font-size: 40px;
	}

	.partner-content {
		background: @grayBgColor;
		display: grid;
		grid-template-columns: 1fr 1fr;

		.partner-item {
			border-right: 1px solid #EAEAF2;
			display: flex;
			flex-direction: column;
			padding: 70px 100px 50px 130px;
			gap: 20px;

			.partner-item {
				border: 1px red solid;

				.partner-item-img {
					width: 42px;
					height: 42px;
				}
			}

			.partner-item-title {
				font-size: @fontSize20;
			}

			.partner-item-info {
				font-size: @fontSize14;
				color: @mainGrayColor;
			}
		}


	}
}



@keyframes scaleImage {
	0% {
		transform: scale(1);
	}

	100% {
		transform: scale(1.1);
	}
}

.footer {}

@media @mobile {
	.content {
		padding: 40px 16px 30px;

		.content-title {
			font-size: 24px;
			margin-bottom: 30px;
			line-height: 1.3;
		}

		.customer-content {
			grid-template-columns: 1fr;
			column-gap: 0;
			row-gap: 24px;

			.customer-item {
				.customer-item-title {
					margin: 16px 0 12px;
					font-size: 18px;
				}

				.customer-item-info {
					font-size: 14px;
					line-height: 1.5;
					-webkit-line-clamp: 3;
				}
			}
		}
	}

	.partner {
		.partner-title {
			padding: 40px 16px 30px;
			font-size: 24px;
			line-height: 1.3;
		}

		.partner-content {
			grid-template-columns: 1fr;

			.partner-item {
				border-right: none;
				border-bottom: 1px solid #EAEAF2;
				padding: 30px 16px;
				gap: 16px;

				&:last-child {
					border-bottom: none;
				}

				.partner-item-img {
					width: 36px;
					height: 36px;
				}

				.partner-item-title {
					font-size: 18px;
				}

				.partner-item-info {
					font-size: 14px;
					line-height: 1.5;
				}
			}
		}
	}

}
</style>
